import { render, staticRenderFns } from "./termsModal.vue?vue&type=template&id=285fe2d1"
import script from "./termsModal.vue?vue&type=script&lang=js"
export * from "./termsModal.vue?vue&type=script&lang=js"
import style0 from "./termsModal.vue?vue&type=style&index=0&id=285fe2d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports